import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { CentralIntakeService } from "../../../services/central-intake.service";
import {
    IApplicationAndAccountQueryParam,
    IDeleteDocumentQueryParam,
    IUploadReferralDocumentQuery
} from "../../vue-interfaces/i-get-referral";

import FormSection from "../FormSection/FormSection.vue";
import PatientDocument from "./PatientDocument.vue";

export default defineComponent({
    inject: ["dialogRef"],

    components: {
        PatientDocument,
        FormSection
    },

    data(vm) {
        return {
            _centralIntake: null,
            application: null as number,
            accountId: null as string,
            referralId: null as string,
            patientId: null as string,
            providerId: null as string,
            isPalliative: false as boolean,
            dialogReference: this.dialogRef as any
        };
    },

    created() {
        this.application = Number(this.dialogReference.data.application);
        this.accountId = this.dialogReference.data.accountId;
        this.patientId = this.dialogReference.data.patientId;
        this.referralId = this.dialogReference.data.referralId;
        this.providerId = this.dialogReference.data.providerId;
        this.isPalliative = this.dialogReference.data.isPalliative ?? false;
        this._centralIntake = Container.instance.get(CentralIntakeService);
    },

    methods: {
        uploadDocument(referralId: string, newDocument: IUploadReferralDocumentQuery) {
            return this._centralIntake.uploadDocument(referralId, newDocument);
        },

        deleteDocument(referralId: string, documentId: string) {
            const deleteDocumentQuery: IDeleteDocumentQueryParam = {
                referralId: referralId,
                application: this.application,
                accountId: this.accountId
            };
            return this._centralIntake.deleteDocument(deleteDocumentQuery, documentId);
        },

        getReferralDocuments(referralId: string) {
            const getReferralDocumentQuery: IApplicationAndAccountQueryParam = {
                application: this.application,
                agencyId: this.accountId
            };
            return this._centralIntake.getReferralDocuments(referralId, getReferralDocumentQuery);
        },

        closeAddDocumentsDialog() {
            this.dialogReference.close();
        }
    }
});
